import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';
import styled from 'styled-components';
import tw from 'twin.macro';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 100%;
  padding-right: 0;
  @media (${MEDIA_QUERIES.laptopL}) {
    grid-template-columns: auto 300px;
    grid-gap: 64px;
    padding-right: 64px;
  }
  @media (${MEDIA_QUERIES.desktopL}) {
    grid-gap: 172px;
    padding-right: 0;
  }
`;

export const Container = styled.article`
  @media (${MEDIA_QUERIES.desktop}) {
    width: 904px;
  }
  *::selection {
    color: ${({ theme }) => theme.colors.background};
    background: ${({ theme }) => theme.colors.title};
  }
`;

export const Divider = styled.hr`
  ${tw`h-0.5 border-0 mt-8 mb-10 bg-black col-start-1 col-span-12 md:col-start-2 md:col-span-10  2xl:col-span-full 2xl:col-start-1`}
`;

export const Sidebar = styled.div<{ marginTop?: number }>`
  display: none;
  flex-direction: column;
  gap: 32px;
  margin-top: ${({ marginTop }) => marginTop && `${marginTop}px`};
  @media (${MEDIA_QUERIES.laptopL}) {
    display: flex;
  }
`;
